import i18n from '@/lib/i18n'

export const BRAND_TITLE = i18n.t('brand.item.title')
